import React from "react";
import { Button, Modal } from 'react-bootstrap';
import styles from '../../../styles/MP/RapportReprovado.module.scss';

const ModalCad = ({ showCad, handleCloseCad, pedidoSelecionado, handleEnviarCad, envio }) => {
    const send = {...pedidoSelecionado, ...envio}
    return (
        <Modal
            show={showCad}
            onHide={handleCloseCad}
            backdrop="static"
            keyboard={false}
            centered
            size='sm'
        >
            <Modal.Header>
                <Modal.Title>Envio CAD</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span>Deseja enviar o <strong>pedido {pedidoSelecionado.PEDIDO}</strong> para o CAD?</span>
            </Modal.Body>
            <Modal.Footer className={styles.modalFooter}>
                <Button
                    variant="outline-danger"
                    className={styles.modalBtn}
                    onClick={handleCloseCad}
                >
                    Voltar
                </Button>
                <Button
                    variant="outline-success"
                    className={styles.modalBtn}
                    onClick={() => handleEnviarCad(send)}
                >
                    Enviar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalCad;
